<template>
    <div style="position: relative">
        <div class="filters">
            <h5>FILTER:</h5>
            <div
                v-if="moje_firmy.length > 0"
                :class="
                    show_window == 0
                        ? 'offer_status_btn active'
                        : 'offer_status_btn'
                "
                @click="changeWindow(0)"
            >
                <span
                    v-if="selectedMyCompanies.length > 0"
                    class="something_selected"
                ></span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                >
                    <path
                        d="M12 4.00002H9.5V3.5C9.5 2.9485 9.05152 2.5 8.5 2.5H5.50001C4.9485 2.5 4.50001 2.94847 4.50001 3.5V3.99999H2.00003C1.4485 4.00002 1.00003 4.44849 1.00003 5V6.49999C1.00003 7.05152 1.4485 7.49999 2.00003 7.49999H6.00002V7.24998C6.00002 7.1118 6.11184 6.99998 6.25003 6.99998H7.75002C7.88821 6.99998 8.00003 7.1118 8.00003 7.24998V7.49999H12C12.5515 7.49999 13 7.05152 13 6.49999V5C13 4.44849 12.5515 4.00002 12 4.00002ZM8.5 4.00002H5.50001V3.5H8.5V4.00002Z"
                    />
                    <path
                        d="M12.8613 7.76981C12.7761 7.72758 12.6743 7.73735 12.5991 7.79447C12.4214 7.929 12.2143 8.00004 11.9999 8.00004H8.00001V8.75003C8.00001 8.88822 7.88819 9.00004 7.75 9.00004H6.25001C6.11182 9.00004 6 8.88822 6 8.75003V8.00004H2.00003C1.78568 8.00004 1.57865 7.929 1.4009 7.79447C1.32546 7.73686 1.2239 7.72708 1.13869 7.76981C1.05375 7.81207 1.00003 7.89872 1.00003 7.99371V11.5C1.00003 12.0515 1.4485 12.5 2.00003 12.5H12C12.5515 12.5 13 12.0516 13 11.5V7.99371C13 7.89872 12.9463 7.81207 12.8613 7.76981Z"
                    />
                </svg>
                <span>Moja firma</span>
            </div>
            <div
                :class="
                    show_window == 1
                        ? 'offer_status_btn active'
                        : 'offer_status_btn'
                "
                @click="changeWindow(1)"
            >
                <span
                    v-if="selectedStates.length > 0"
                    class="something_selected"
                ></span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="7"
                    viewBox="0 0 6 7"
                    fill="none"
                >
                    <circle cx="3" cy="3.5" r="3" />
                </svg>
                <span>Stav ponuky</span>
            </div>
            <div
                v-if="findMyUsers.length > 0"
                :class="
                    show_window == 2
                        ? 'offer_status_btn active'
                        : 'offer_status_btn'
                "
                @click="changeWindow(2)"
            >
                <span
                    v-if="selectedUsers.length > 0"
                    class="something_selected"
                ></span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                >
                    <path
                        d="M12.25 4.67288V2.28938C12.25 1.54913 11.914 1.24988 11.0793 1.24988H8.95826C8.12351 1.24988 7.78751 1.54913 7.78751 2.28938V4.66763C7.78751 5.41313 8.12351 5.70713 8.95826 5.70713H11.0793C11.914 5.71238 12.25 5.41313 12.25 4.67288Z"
                    />
                    <path
                        d="M12.25 10.5792V8.45823C12.25 7.62348 11.914 7.28748 11.0793 7.28748H8.95826C8.12351 7.28748 7.78751 7.62348 7.78751 8.45823V10.5792C7.78751 11.414 8.12351 11.75 8.95826 11.75H11.0793C11.914 11.75 12.25 11.414 12.25 10.5792Z"
                    />
                    <path
                        d="M6.2125 4.67288V2.28938C6.2125 1.54913 5.8765 1.24988 5.04175 1.24988H2.92075C2.086 1.24988 1.75 1.54913 1.75 2.28938V4.66763C1.75 5.41313 2.086 5.70713 2.92075 5.70713H5.04175C5.8765 5.71238 6.2125 5.41313 6.2125 4.67288Z"
                    />
                    <path
                        d="M6.2125 10.5792V8.45823C6.2125 7.62348 5.8765 7.28748 5.04175 7.28748H2.92075C2.086 7.28748 1.75 7.62348 1.75 8.45823V10.5792C1.75 11.414 2.086 11.75 2.92075 11.75H5.04175C5.8765 11.75 6.2125 11.414 6.2125 10.5792Z"
                    />
                </svg>
                <span>{{ $t('offer.filter_my_users') }}</span>
            </div>
        </div>
        <div
            v-show="show_window == 0"
            class="offer_status_box my_companies"
            v-click-outside-filter="closePopups"
        >
            <div
                class="checkbox"
                v-for="item in moje_firmy"
                :key="item.id"
                @click="setFilterCheckbox(item.id, selectedMyCompanies)"
            >
                <svg
                    class="checkbox__icon"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="0.5"
                        y="0.5"
                        width="13"
                        height="13"
                        rx="2.5"
                        fill="white"
                        stroke="#DDE3E8"
                    />
                    <path
                        :class="
                            selectedMyCompanies.includes(item.id)
                                ? 'tick checked'
                                : 'tick'
                        "
                        stroke="#212541"
                        fill="none"
                        stroke-linecap="round"
                        stroke-width="2"
                        d="M3 8l5 3 3-8"
                    />
                </svg>
                <span class="checkbox__label">{{ item.nazov }}</span>
            </div>
        </div>
        <div
            v-show="show_window == 1"
            class="offer_status_box offer_state"
            v-click-outside-filter="closePopups"
        >
            <div
                class="checkbox"
                v-for="item in offer_states"
                :key="item.id"
                @click="setFilterCheckbox(item.id, selectedStates)"
            >
                <svg
                    class="checkbox__icon"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        x="0.5"
                        y="0.5"
                        width="13"
                        height="13"
                        rx="2.5"
                        fill="white"
                        stroke="#DDE3E8"
                    />
                    <path
                        :class="
                            selectedStates.includes(item.id)
                                ? 'tick checked'
                                : 'tick'
                        "
                        :stroke="item.color"
                        fill="none"
                        stroke-linecap="round"
                        stroke-width="2"
                        d="M3 8l5 3 3-8"
                    />
                </svg>
                <span
                    class="checkbox_dot"
                    :style="'background-color: ' + item.color"
                ></span>
                <span class="checkbox__label">{{ item.state }}</span>
            </div>
        </div>
        <div
            v-show="show_window == 2"
            class="offer_status_box my_users"
            v-click-outside-filter="closePopups"
        >
            <div class="my_users_filter_box">
                <input
                    v-model="search_my_users"
                    class="my_users_filter"
                    type="text"
                    :placeholder="$t('offer.filter_find_ph')"
                />
                <svg
                    class="my_users_filter_svg"
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                >
                    <path
                        d="M13.125 13.125L9.375 9.375L13.125 13.125ZM10.625 6.25C10.625 6.82453 10.5118 7.39344 10.292 7.92424C10.0721 8.45504 9.74985 8.93734 9.34359 9.34359C8.93734 9.74985 8.45504 10.0721 7.92424 10.292C7.39344 10.5118 6.82453 10.625 6.25 10.625C5.67547 10.625 5.10656 10.5118 4.57576 10.292C4.04496 10.0721 3.56266 9.74985 3.15641 9.34359C2.75015 8.93734 2.42789 8.45504 2.20803 7.92424C1.98816 7.39344 1.875 6.82453 1.875 6.25C1.875 5.08968 2.33594 3.97688 3.15641 3.15641C3.97688 2.33594 5.08968 1.875 6.25 1.875C7.41032 1.875 8.52312 2.33594 9.34359 3.15641C10.1641 3.97688 10.625 5.08968 10.625 6.25Z"
                        stroke="#9598A7"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div class="scroll_container">
                <label
                    class="checkbox"
                    v-for="item in findMyUsers"
                    :key="item.id"
                    @click="setFilterCheckbox(item.id, selectedUsers)"
                >
                    <svg
                        class="checkbox__icon"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="0.5"
                            y="0.5"
                            width="13"
                            height="13"
                            rx="2.5"
                            fill="white"
                            stroke="#DDE3E8"
                        />
                        <path
                            :class="
                                selectedUsers.includes(item.id)
                                    ? 'tick checked'
                                    : 'tick'
                            "
                            stroke="#212541"
                            fill="none"
                            stroke-linecap="round"
                            stroke-width="2"
                            d="M3 8l5 3 3-8"
                        />
                    </svg>
                    <span class="checkbox__label"
                        >{{ item.meno }} {{ item.priezvisko }}</span
                    >
                </label>
                <h4 v-if="findMyUsers.length <= 0" class="my_user_not_exist">
                    {{ $t('offer.filter_not_found') }}
                </h4>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "offer_states",
        "sub_users",
        "moje_firmy",
        "selectedStates",
        "selectedUsers",
        "selectedMyCompanies",
    ],
    data() {
        return {
            show_window: -1,
            search_my_users: "",
        };
    },
    methods: {
        setFilterCheckbox(id, array) {
            const index = array.indexOf(id);
            if (index !== -1) {
                array.splice(index, 1);
            } else {
                array.push(id);
            }
        },
        changeWindow(id) {
            this.show_window == id
                ? (this.show_window = -1)
                : (this.show_window = id);
        },
        closePopups() {
            this.show_window !== -1 ? (this.show_window = -1) : "";
        },
    },
    computed: {
        findMyUsers() {
            if (!this.search_my_users) {
                return this.sub_users;
            }
            const searchQuery = this.search_my_users.toLowerCase();
            return this.sub_users.filter((user) => {
                var name = user.meno.toLowerCase().includes(searchQuery);
                var lname = user.priezvisko.toLowerCase().includes(searchQuery);
                return name || lname;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.filters {
    display: flex;
    align-items: center;
    margin-left: 20px;
    @media (max-width: 600px) {
        margin-top: 20px;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 0;
        gap: 10px;
    }
    h5 {
        color: var(--Blue, #212541);
        font-family: Montserrat;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        margin-right: 17px;
    }
}
.offer_status_btn {
    position: relative;
    width: max-content;
    border-radius: 6px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-items: center;
    gap: 10px;
    z-index: 10;
    cursor: pointer;
    margin-right: 11px;
    background: var(--Blue, #fff);
    svg circle,
    svg path {
        fill: var(--White, #212541);
    }
    span {
        color: var(--White, #212541);
    }
    &.active {
        background: var(--Blue, #212541);
        svg circle,
        svg path {
            fill: var(--White, #fff);
        }
        span {
            color: var(--White, #fff);
        }
    }
    span {
        text-align: center;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
}
span.something_selected {
    position: absolute;
    top: 5px;
    right: 5px;

    width: 4px;
    height: 4px;
    border-radius: 5px;
    background-color: #f93c34;
}
.offer_status_box {
    z-index: 1000;
    top: 49px;
    position: absolute;
    padding: 13px 5px;
    width: 213px;
    border-radius: 5px;
    border: 1px solid #f3f4f6;
    background: #fff;
    box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.05);
    &.my_companies {
        left: 46px;
        @media (max-width: 600px) {
            left: 140px;
            top: 42px;
        }
    }
    &.offer_state {
        left: 186px;
        @media (max-width: 600px) {
            left: 140px;
            top: 42px;
        }
    }
    &.my_users {
        left: 338px;
        max-height: 219px;
        @media (max-width: 600px) {
            left: 140px;
            top: 42px;
        }
        .scroll_container {
            overflow-y: auto;
            max-height: 140px;
            width: 199px;
            &::-webkit-scrollbar {
                width: 2px;
            }

            &::-webkit-scrollbar-track {
                background: #f3f4f6;
            }

            &::-webkit-scrollbar-thumb {
                background: #9598a7;
                border-radius: 6px;
                opacity: 0.9;
                &:hover {
                    opacity: 1;
                }
            }
        }
        h4.my_user_not_exist {
            color: var(--Blue, #212541);
            font-family: Roboto;
            font-size: 13px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin-left: 8px;
        }
        .my_users_filter_box {
            position: relative;
            display: flex;
            align-items: center;
            width: 194px;
            margin: 0 auto;
            margin-bottom: 20px;
        }

        .my_users_filter {
            width: 194px;
            height: 35px;
            background: #ffffff;
            border: 1px solid #dde3e8;
            box-sizing: border-box;

            color: var(--Blue, #212541);
            font-family: Montserrat;
            font-size: 10px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            letter-spacing: 1.2px;
            text-transform: uppercase;
            padding-left: 24px;
        }
        .my_users_filter_svg {
            position: absolute;
            left: 6px;
        }
    }
    .checkbox_dot {
        width: 6px;
        height: 6px;
        background-color: #34d399;
        border-radius: 6px;
        margin-left: 8px;
    }
    .checkbox {
        $block: &;

        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 4px;
        margin: 0;
        &:hover {
            border-radius: 4px;
            background: #f3f4f6;
        }
        &__input {
            position: absolute;
            width: 14px;
            height: 14px;
            opacity: 0;
            cursor: pointer;
        }

        &__icon {
            width: 14px;
            height: 14px;
            flex-shrink: 0;
            overflow: visible;

            .tick {
                stroke-dasharray: 20px;
                stroke-dashoffset: 20px;
                transition: stroke-dashoffset 0.2s ease-out;
            }
            .tick.checked {
                stroke-dashoffset: 0;
            }
        }

        .checkbox__label {
            text-transform: capitalize;
            color: var(--Blue, #212541);
            font-family: Roboto;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin-left: 8px;
        }
    }
}
</style>
